import React from 'react';
import type { CardProps } from './CardProps';
import { CardWrapper, Header, Content, Footer } from './card.style';

const Card: React.FC<CardProps> = ({ header, children, footer, boxShadow, className = '' }) => {
    return (
        <CardWrapper boxShadow={boxShadow} className={className} data-testid="card-wrapper">
            {header && <Header>{header}</Header>}
            <Content>{children}</Content>
            {footer && <Footer>{footer}</Footer>}
        </CardWrapper>
    );
};

export default Card;
